import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowUpRight: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-up-right"><path d="M18.25 15.25V5.75H8.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M6 18L17.6002 6.39978" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowUpRight;
